import { createFileRoute, notFound } from "@tanstack/react-router";
import { buildPageHead } from "@/lib/seo";
import BlogTopic from "@/pages/BlogTopic";

export const Route = createFileRoute("/blog/topic/$tag/")({
  // The library dataset is imported lazily so it stays out of the entry
  // bundle; only the small head fields are returned (they get serialized
  // into the SSR payload).
  loader: async ({ params }) => {
    const { getTag, getPostsByTag } = await import("@/data/library");
    const tag = getTag(params.tag);
    if (!tag) throw notFound();
    // No blog posts carry this tag — 404 so thin pages never get indexed.
    const posts = getPostsByTag(tag.slug).filter((p) => p.href.startsWith("/blog/"));
    if (posts.length === 0) throw notFound();
    // Borrow the title-cased name from the registry seoTitle ("Web Analytics:
    // Articles & Guides | Bigdelta" → "Web Analytics") but keep a distinct
    // descriptor — the hub page at /hub/$tag uses the seoTitle verbatim.
    const titleName = tag.seoTitle?.split(":")[0].trim() ?? tag.name;
    return {
      title: `${titleName} Blog Posts | Bigdelta`,
      description: tag.blurb,
      slug: tag.slug,
    };
  },
  head: ({ loaderData }) => {
    if (!loaderData) return {};
    return buildPageHead({
      title: loaderData.title,
      description: loaderData.description,
      path: `/blog/topic/${loaderData.slug}`,
    });
  },
  component: () => <BlogTopic scope="blog" />,
});
